import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {PostSemanticSearchPayloadDto} from "../types/PostSemanticSearchPayloadDto";
import {PostSemanticSearchResponseDto} from "../types/PostSemanticSearchResponseDto";

const postSemanticSearchLink = apiLink.semanticSearch.base()();

export const postSemanticSearchApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postSemanticSearch: build.mutation<PostSemanticSearchResponseDto, PostSemanticSearchPayloadDto>({
            query: (payload) => ({
                url: postSemanticSearchLink,
                method: "POST",
                body: payload
            })
        })
    })
});

export const {usePostSemanticSearchMutation} = postSemanticSearchApi;
import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {PostSemanticSearchPayloadDto} from "../types/PostSemanticSearchPayloadDto";
import {PostSemanticSearchResponseDto} from "../types/PostSemanticSearchResponseDto";

const postSemanticSearchLink = apiLink.semanticSearch.base()();

export const postSemanticSearchApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postSemanticSearch: build.mutation<PostSemanticSearchResponseDto, PostSemanticSearchPayloadDto>({
            query: (payload) => ({
                url: postSemanticSearchLink,
                method: "POST",
                body: payload
            })
        })
    })
});

export const {usePostSemanticSearchMutation} = postSemanticSearchApi;
